import React from 'react';
import PropTypes from 'prop-types';
import { Pill } from '@storable/canaveral-components';
import gql from 'graphql-tag';
import cx from 'classnames';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  locale: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
  }).isRequired,
  showName: PropTypes.bool,
};

const defaultProps = {
  className: undefined,
  showName: undefined,
};

const LocalePill = ({
  className,
  locale: {
    code,
    name,
  },
  showName,
}) => {
  const pillClasses = cx(styles.pill, className);

  return (
    <span className={className}>
      <Pill className={pillClasses}>
        {code}
      </Pill>
      {showName && (
        <span className={styles.name}>
          {name}
        </span>
      )}
    </span>
  );
};

LocalePill.propTypes = propTypes;
LocalePill.defaultProps = defaultProps;

LocalePill.fragments = {
  locale: gql`
    fragment LocalePillLocale on Locale {
      name
      code
    }
  `,
};

export default LocalePill;
